var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.display && _vm.needsConfirm)?_vm._t("default",function(){return [_vm._v(_vm._s(_vm.message))]},{"confirm":_vm.confirmData,"needsConfirm":_vm.needsConfirm}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }